import React from 'react';
import manifest from './images';

// Responsive image for assets generated in /assets/images/cpr (<name>-<width>.webp|jpg).
// Lazy by default; pass priority for the above-the-fold hero.
function Picture({name, alt, sizes = '100vw', priority = false, className, imgClassName}) {
    const entry = manifest[name];
    if (!entry) {
        return null;
    }
    const base = `${process.env.PUBLIC_URL}/assets/images/cpr/${name}`;
    const srcSet = (ext) => entry.widths.map(w => `${base}-${w}.${ext} ${w}w`).join(', ');
    const fallbackWidth = entry.widths[Math.min(1, entry.widths.length - 1)];

    return (
        <picture className={className}>
            <source type="image/webp" srcSet={srcSet('webp')} sizes={sizes}/>
            <img src={`${base}-${fallbackWidth}.jpg`}
                 srcSet={srcSet('jpg')}
                 sizes={sizes}
                 alt={alt}
                 width={entry.width}
                 height={entry.height}
                 loading={priority ? 'eager' : 'lazy'}
                 decoding={priority ? 'sync' : 'async'}
                 className={imgClassName}/>
        </picture>
    );
}

export default Picture;
